import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { theme } from 'utils/style/theme';
import { IDLCDetailProps, IDLCLocalProps } from 'utils/types/storyTypes';
import {
  useDlcBannerDrop,
  useDlcDetail,
  useDlcTypeDrop,
  useDlcUpdate,
} from 'apis/story/dlcApis';
import DefaultButton from 'components/button/DefaultButton';
import InputFlexBox from 'components/container/InputFlexBox';
import InputWrappingBox from 'components/container/InputWrappingBox';
import SubmitFlexBox from 'components/container/SubmitFlexBox';
import DefaultInput from 'components/input/DefaultInput';
import DefaultLayout from 'components/layout/DefaultLayout';
import DefaultSelect from 'components/select/DefaultSelect';
import DLCLocalForm from './DLCLocalForm';
/**
 * * 작품 관리 (오토메) - DLC 메인 정보 수정
 */

const DLCUpdatePage = () => {
  const { projectId, dlcId } = useParams();
  const navigate = useNavigate();
  const [detailData, setDetailData] = useState<IDLCDetailProps>();
  const [langList, setLangList] = useState<IDLCLocalProps[]>([
    {
      key: 0,
      lang: 'KO',
      dlc_title: '',
      dlc_summary: '',
      banner_id: -1,
      banner_url: '',
      banner_key: '',
    },
  ]);

  const { data: dlcTypeDropList } = useDlcTypeDrop();
  const { data: dlcBannerImgDropList } = useDlcBannerDrop(projectId!);
  const { data: dlcDetailData } = useDlcDetail(
    projectId,
    dlcId,
    setDetailData,
    langList,
    setLangList,
  );

  const { mutate: dlcUpdate } = useDlcUpdate();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setDetailData({ ...detailData!, [name]: value });
  };
  const handleSelectChange = (value: string, op: any) => {
    setDetailData({ ...detailData!, [op.name]: value });
  };

  /// 서버 전송
  const handleSubmit = () => {
    dlcUpdate({ projectId, dlcId, detailData, langList });
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  return (
    <DefaultLayout>
      <SubmitFlexBox>
        <>
          <DefaultButton backColor={theme.colors.sub} onClick={handleGoBack}>
            목록보기
          </DefaultButton>
          <DefaultButton onClick={handleSubmit}>저장하기</DefaultButton>
        </>
      </SubmitFlexBox>
      <InputFlexBox style={{ marginTop: '3rem' }}>
        <InputWrappingBox left>
          <DLCLocalForm
            langList={langList}
            setLangList={setLangList}
            dlcBannerImgDropList={dlcBannerImgDropList}
          />
        </InputWrappingBox>
        <InputWrappingBox>
          <DefaultInput
            title='관리형 이름'
            name='dlc_name'
            value={detailData?.dlc_name}
            onChange={handleInputChange}
          />
          <DefaultSelect
            title='DLC 타입'
            name='dlc_type'
            value={detailData?.dlc_type}
            optionList={dlcTypeDropList}
            onChange={handleSelectChange}
          />
          <DefaultInput
            title='판매 가격'
            name='price'
            value={detailData?.price}
            onChange={handleInputChange}
          />
          <DefaultInput
            title='할인 가격'
            name='sale_price'
            value={detailData?.sale_price}
            onChange={handleInputChange}
          />
          <DefaultInput
            title='DLC 메인 인물'
            name='cast1'
            value={detailData?.cast1}
            onChange={handleInputChange}
          />
          <DefaultInput
            title='DLC 등장 인물'
            name='cast2'
            value={detailData?.cast2}
            onChange={handleInputChange}
            style={{ marginBottom: '0.2rem' }}
          />
          <DefaultInput
            name='cast3'
            value={detailData?.cast3}
            onChange={handleInputChange}
            style={{ marginBottom: '0.2rem' }}
          />
          <DefaultInput
            name='cast4'
            value={detailData?.cast4}
            onChange={handleInputChange}
          />
          <></>
        </InputWrappingBox>
      </InputFlexBox>
    </DefaultLayout>
  );
};

export default DLCUpdatePage;
